import { jsx as _jsx } from "react/jsx-runtime";
import Settings from './tab-settings.svg';
import Camera from './tab-camera.svg';
import Cam from './tab-cam.svg';
import Reports from './tab-reports.svg';
import State from './tab-state.svg';
import Diagnostics from './tab-diagnostics.svg';
import Events from './tab-events.svg';
import RF from './tab-rf.svg';
import Map from './tab-map.svg';
import Service from './tab-service.svg';
import Guard from './tab-guard.svg';
import Stats from './tab-stats.svg';
import Temperature from './tab-temperature.svg';
import Z3KConfig from './custom/adjust.svg';
import MoreButton from './more-button.svg';
import { CustomIcon } from 'console/shared/components/icon/custom';
const style = { width: 26, height: 26 };
export function getNavigationIcon(tab_name) {
    switch (tab_name) {
        case 'ui-icon-tab-temperature':
            return _jsx(CustomIcon, { color: "inherit", Icon: Temperature, ...style });
        case 'ui-icon-tab-state':
            return _jsx(CustomIcon, { color: "inherit", Icon: State, ...style });
        case 'ui-icon-tab-stats':
            return _jsx(CustomIcon, { color: "inherit", Icon: Stats, ...style });
        case 'ui-icon-tab-events':
            return _jsx(CustomIcon, { color: "inherit", Icon: Events, ...style });
        case 'ui-icon-tab-diagnostics':
            return _jsx(CustomIcon, { color: "inherit", Icon: Diagnostics, ...style });
        case 'ui-icon-tab-guard':
            return _jsx(CustomIcon, { color: "inherit", Icon: Guard, ...style });
        case 'ui-icon-tab-map':
            return _jsx(CustomIcon, { color: "inherit", Icon: Map, ...style });
        case 'ui-icon-tab-service':
            return _jsx(CustomIcon, { color: "inherit", Icon: Service, ...style });
        case 'ui-icon-tab-reports':
            return _jsx(CustomIcon, { color: "inherit", Icon: Reports, ...style });
        case 'ui-icon-tab-cam':
            return _jsx(CustomIcon, { color: "inherit", Icon: Cam, ...style });
        case 'ui-icon-tab-camera':
            return _jsx(CustomIcon, { color: "inherit", Icon: Camera, ...style });
        case '.ui-icon-tab-z3k-config':
            return _jsx(CustomIcon, { color: "inherit", Icon: Z3KConfig, ...style });
        case 'ui-icon-tab-settings':
            return _jsx(CustomIcon, { color: "inherit", Icon: Settings, ...style });
        case 'ui-rf-tab-icon':
            return _jsx(CustomIcon, { color: "inherit", Icon: RF, ...style });
        case 'more':
            return _jsx(CustomIcon, { color: "inherit", Icon: MoreButton, ...style });
        default:
            return null;
    }
}
